<p-toast position="top-right" key="notification-message"></p-toast>

<form>

    <div class="p-d-flex p-ai-center p-jc-center" style="min-height: 37vh;" *ngIf="isLoading">
        <div class="p-grid">
            <div class="p-col-12 p-text-center">
                <i class="pi pi-spinner pi-spin p-text-secondary" style="font-size: 1.75rem"></i>
                <div class="p-text-secondary p-mt-3">Loading Config !</div>
            </div>
        </div>
    </div>

    <div class="p-d-flex p-ai-center p-jc-center" style="min-height: 37vh;" *ngIf="!notificationConfigList && !isLoading">
        <div class="p-grid">
            <div class="p-col-12 p-text-center">
                <div class="p-text-secondary p-mt-3">No Notification Config Found !</div>
            </div>
        </div>
    </div>


    <div *ngIf="!isLoading && notificationConfigList.toString().length > 0">
        <div class="p-grid p-mt-3 divider-bottom p-ai-center">
            <div class="p-col-3 divider-right p-mb-2 p-text-wrap">
                <h5>Job Types (FCL, LCL, AIR, Custom, Transportation)</h5>
            </div>

            <div class="p-col-3 p-text-center divider-right p-mb-2">
                <h5>Email</h5>
            </div>

            <div class="p-col-3 p-text-center divider-right p-mb-2">
                <h5>WhatsApp</h5>
            </div>

            <div class="p-col-3 p-text-center p-mb-2">
                <h5>In App</h5>
            </div>
        </div>


        <div *ngFor="let notificationConfigForm of notificationConfigListFormArray?.controls">
            <div [formGroup]="notificationConfigForm">

                <div class="p-grid divider-bottom p-py-3 p-ai-center">
                    <div class="p-col-3 divider-right">
                        {{notificationConfigForm?.value?.event}}
                    </div>

                    <div class="p-col-3 p-text-center divider-right">
                        <p-checkbox [formControl]="notificationConfigForm.controls['isEmailNotificationEnable']"
                                    binary="true"></p-checkbox>
                    </div>

                    <div class="p-col-3 p-text-center divider-right">
                        <p-checkbox [formControl]="notificationConfigForm.controls['isWhatsAppNotificationEnable']"
                                    binary="true"></p-checkbox>
                    </div>

                    <div class="p-col-3 p-text-center divider-right">
                        <p-checkbox disabled="disabled" [formControl]="notificationConfigForm.controls['isInAppNotificationEnable']"
                                    binary="true"></p-checkbox>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="p-mt-3 p-d-flex p-ai-center p-jc-center">
        <div>
            <button [disabled]="isLoading" (click)="updateNotificationConfig()" type="button" pButton pRipple label="Save"
                    class="p-button-secondary"></button>
        </div>
    </div>
</form>
